/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  forwardRef, useEffect,
} from 'react';
import { TransitionProps } from '@mui/material/transitions';
import { useForm } from 'react-hook-form';
import {
  Button,
  Dialog, DialogContent, DialogTitle, Grid, IconButton, Zoom,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import RequiredFiled from '../../../../Common/RequiredField';
import ComponentTextInput from '../../../../Common/ComponentTextinput/ComponentTextInput';
import ComponentSelectInput from '../../../../Common/ComponentSelectInput';
import { AddZipCodeFields, AddZipCodeFieldsEnum, AddZipCodeModalTypes } from '../../utils/types';
import { addZipCodeSchema } from '../../utils/validation';
import { RootState } from '../../../../redux/rootState';
import { createPincodeStart } from '../../../../redux/masters/masterSlice';

const Transition = forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) => <Zoom ref={ref} {...props} />);

function AddZipCodeModal({
  show, setOpenFrom,
}: AddZipCodeModalTypes): JSX.Element {
  const { countries } = useSelector((state: RootState) => state.masterDataReducer);
  const {
    control, formState: { errors }, reset, handleSubmit,
  } = useForm<AddZipCodeFields>({
    defaultValues: {
      [AddZipCodeFieldsEnum.zipCode]: '',
      [AddZipCodeFieldsEnum.stateCode]: '',
      [AddZipCodeFieldsEnum.cityCode]: '',
      [AddZipCodeFieldsEnum.countryCode]: '',
    },
    resolver: yupResolver(addZipCodeSchema as ObjectSchema<AddZipCodeFields>),
  });
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpenFrom();
    reset();
  };
  useEffect(() => {
    if (show) {
      reset();
    }
  }, [show]);

  const onSubmit = (data: AddZipCodeFields) => {
    const payload = {
      Pincode: data.zipCode,
      StateCode: data.stateCode,
      StateName: data.stateCode,
      CityName: data.cityCode,
      CityCode: data.cityCode,
      CountryCode: data.countryCode,
    };
    dispatch(createPincodeStart(payload));
    handleClose();
  };

  return (
    <div>
      <Dialog
        maxWidth="sm"
        PaperProps={{
          className: 'paperStyle',
        }}
        open={show}
        transitionDuration={500}
        TransitionComponent={Transition}
        keepMounted
        onClose={setOpenFrom}
      >
        <DialogTitle className="modalHeaderTitle">
          Add Zip Code
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent style={{ padding: '16px 24px' }}>
          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <Grid container spacing={2}>
              <Grid item md={6} sm={12} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Zip
                    <RequiredFiled />
                  </label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name={AddZipCodeFieldsEnum.zipCode}
                    size="small"
                    id={AddZipCodeFieldsEnum.zipCode}
                    errors={errors}
                    inputProps={{ maxLength: 10 }}
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    State Code
                    <RequiredFiled />
                  </label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    inputProps={{ maxLength: 6 }}
                    name={AddZipCodeFieldsEnum.stateCode}
                    size="small"
                    id={AddZipCodeFieldsEnum.stateCode}
                    errors={errors}
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    City
                    <RequiredFiled />
                  </label>
                  <ComponentTextInput
                    className="nonCapitalizeField"
                    control={control}
                    name={AddZipCodeFieldsEnum.cityCode}
                    size="small"
                    id={AddZipCodeFieldsEnum.cityCode}
                    errors={errors}
                    maxTextLength={32}
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Country
                    <RequiredFiled />
                  </label>
                  <ComponentSelectInput
                    control={control}
                    entries={countries}
                    name={AddZipCodeFieldsEnum.countryCode}
                    size="small"
                    errors={errors}
                  />
                </div>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <div className="save_and_next_div">
                  <div>
                    <Button className="button_cancel" onClick={handleClose}>Cancel</Button>
                  </div>
                  <div className="button_margin_left">
                    <Button type="submit" className="button_save_and_next">Save</Button>
                  </div>
                </div>
              </Grid>

            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default AddZipCodeModal;
